import { HelpCircle } from 'lucide-react';
import { useHelp } from '../../contexts/HelpContext';
import styles from './HelpButton.module.css';

export default function HelpButton({ page, panel, slug, className, size = 15, title = 'Help' }) {
  const { openHelp, available } = useHelp();
  // No provider, no dialog to open — don't render a button that does nothing.
  if (!available) return null;
  return (
    <button
      type="button"
      className={className || styles.helpBtn}
      onClick={() => openHelp({ page, panel, slug })}
      title={title}
      aria-label={title}
    >
      <HelpCircle size={size} aria-hidden="true" />
    </button>
  );
}
